<template>
    <div class="question">
        <form :id="'myForm' + question.id" @submit.prevent>
            <div class="question-item">
                <div class="question-number">
                    {{__t('Запитання')}} <strong>{{ currentQuestion + 1 }}</strong> {{__t('з')}} <strong>{{
                    q_length }}</strong>
                </div>
                <div class="question-text">
                    {{ question.title }}
                </div>

                <div class="question-rating">
                    <div class="rating" v-for="index in 5" :key="index">
                        <input type="checkbox" class="rating" :id="'q'+index"  :input_name="question.input_name" @change="checkRating(index)">
                        <label :for="'q'+index"></label>
                    </div>
                </div>

            </div>
            <a href="javascript:;" class="back-btn" :class="{hidden: currentQuestion == 0}" @click="setPrevQuestion">{{__t('Назад')}}</a>

            <button @click="saveData" :class="{disabled: button_disabled}">
                <span v-if="currentQuestion+1 == q_length">{{__t('Відправити')}}</span>
                <span v-if="currentQuestion+1 != q_length">{{__t('Далі')}}</span>
            </button>

        </form>
    </div>
</template>

<script>
  export default {
    name: 'Rating',
    props: ['q_length', 'question', 'formData', 'currentQuestion'],
    data() {
      return {
        _index: 0,
        button_disabled: true
      }
    },
    methods: {
      __t(phrase) {
        return window.__t(phrase);
      },
      checkRating(index) {
        this._index = index;

        let elements = document.getElementsByClassName("rating");
        Array.from(elements).forEach(function (element) {
          element.checked = false;
        });

        for (let i = 1; i <= index; i++) {
          document.getElementById("q" + i).checked = true;
        }

        this.button_disabled = false;

      },
      saveData() {

        var object2 = {};

        object2["value"] = this._index;

        object2["type"] = this.question.type;
        object2["name"] = this.question.input_name;

        var rv = {};

        rv[this.question.id] = object2;

        if (rv.hasOwnProperty(this.question.id)) {
          this.$emit('saveData', rv)
        }


      },
      setPrevQuestion() {
        this.$emit('setPrevQuestion')
      }
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/type_rating.vue